import Head from "next/head";
import React from "react";

const PRECONNECT_URLS = [
  "https://www.googletagmanager.com",
  "https://ogs.google.com",
  "https://www.gstatic.com",
  "https://fonts.gstatic.com",
  "https://fonts.googleapis.com",
  "https://www.googleadservices.com",
  "https://cdn.cookielaw.org",
  "https://edge-platform.sitecorecloud.io",
  "https://cdn.evgnet.com",
  "https://ecolab.us-6.evergage.com",
];

export const Preload = () => {
  return (
    <Head>
      {/* DNS Prefetch — resolve DNS early for external domains */}
      {PRECONNECT_URLS.map((url) => (
        <link
          key={`dns-prefetch-${url}`}
          rel="dns-prefetch"
          href={url.replace("https:", "")}
        />
      ))}

      {/* Preconnect — establish connection early (more aggressive than dns-prefetch) */}
      {PRECONNECT_URLS.map((url) => (
        <link key={`preconnect-${url}`} rel="preconnect" href={url} />
      ))}
      {/* <link
        rel="preload"
        as="style"
        href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&amp;display=swap"
        onLoad={(e) => {
          const link = e.currentTarget;
          link.rel = "stylesheet";
        }}
      />
      <noscript>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&amp;display=swap"
          crossOrigin="anonymous"
        />
      </noscript> */}
    </Head>
  );
};
